import axios from 'axios';
const instance = axios.create({baseURL: 'https://api.dev.mylotspy.com/api/v1'});
export default instance;
